"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodeColors = void 0;
const Defer_1 = require("thingies/lib/Defer");
class CodeColors {
    constructor(workerUrl) {
        this.id = 0;
        this.calls = new Map();
        this.tokenize = async (code, lang) => {
            await this.workerReady;
            const id = this.id++;
            // return [['a'], []];
            const msg = [
                1 /* CompactMessageType.RequestComplete */,
                id,
                'highlight',
                { code, lang },
            ];
            const call = new Defer_1.Defer();
            this.worker.postMessage(msg);
            this.calls.set(id, call);
            return call.promise;
        };
        const ready = new Defer_1.Defer();
        this.workerReady = ready.promise;
        const js = `importScripts("${workerUrl}");`;
        const blob = new Blob([js], { type: 'text/javascript' });
        const objectUrl = URL.createObjectURL(blob);
        this.worker = new Worker(objectUrl);
        URL.revokeObjectURL(objectUrl);
        this.worker.addEventListener('message', (event) => {
            const msg = event.data;
            if (!Array.isArray(msg))
                return;
            switch (msg[0]) {
                case 5 /* CompactMessageType.ResponseComplete */: {
                    const [, id, params] = msg;
                    const call = this.calls.get(id);
                    if (!call)
                        return;
                    this.calls.delete(id);
                    call.resolve(params);
                }
                case 6 /* CompactMessageType.ResponseError */: {
                    const [, id, error] = msg;
                    const call = this.calls.get(id);
                    if (!call)
                        return;
                    this.calls.delete(id);
                    call.reject(error);
                }
                case 8 /* CompactMessageType.Notification */: {
                    if (msg[1] === 'ready')
                        ready.resolve();
                }
            }
        });
    }
}
exports.CodeColors = CodeColors;
//# sourceMappingURL=CodeColors.js.map